import { combineReducers } from 'redux'
import Products from './productItem'

const rootReducer = combineReducers({
    productsInfo : Products
});

export default rootReducer